
// npm packages
import React, { useState, useContext } from "react";

// custom pages
import TimesheetSummary from "./TimesheetSummaryReports/TimesheetSummary";

// material ui
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Card from "@mui/material/Card";
import ProjectSetup from "./ProjectSetup";

import Context from "context/context";
import EmployeeNonComplainceSummary from "./EmployeeNonComplainceSummary";
import EmployeeInfoReport from "./EmployeeRoster/EmployeeInfoReport";
import EmployeeTimesheetDetails from "./EmployeeTimesheetDetails/EmployeeTimesheetDetails";
import EmployeeLeaveDetails from "./EmployeeLeaveDetails/EmployeeLeaveDetails";
import EmployeeManagerInformation from "./EmployeeManagerInformation/EmployeeManagerInformation";
import EmployeeLeavesSummary from "./EmployeeLeavesSummary/EmployeeLeavesSummary";
import { ListSubheader } from "../../../../node_modules/@mui/material/index";
import EmployeeAttendanceDetails from "./EmployeeAttendanceDetails/EmployeeAttendanceDetails";
import RpEmployeeAttendanceDetails from "./RPEmployeeAttendanceDetails/RpEmployeeAttendanceDetails";
import EmployeeResignationDetails from "./EmployeeResignationDetails/EmployeeResignationDetails";

import ExperienceSubmissionReport from "./ExperienceSubmissionReport/ExperienceSubmissionReport";
import EmployeeDocuments from "./EmployeeDocuments/EmployeeDocuments"

export default function Reports() {
  const { state } = useContext(Context);
  const [disableDropdown, setDisableDropdown] = useState(false);
  const [currentReport, setCurrentReport] = useState(null);
  const [roleCode, setRoleCode] = useState(state.role.roleCode);



  const reports2 =
    roleCode === "R004"

      ? {
        "Timesheet": [
          { id: 1, reportName: "Project-Level Summary Report" },
          { id: 3, reportName: "Non-Compliance Summary Report" },
          { id: 5, reportName: "Employee Timesheet Details" },
        ],
        "Leave": [
          { id: 6, reportName: "Employee Leave Details" },
        ],
        "Employee Information": [
          { id: 10, reportName: "Rp Attendance Report" },
        ],
      }
      : {
        "Timesheet": [
          {
            id: 1,
            reportName: "Project-Level Summary Report",
          },
          {
            id: 2,
            reportName: "Weekly Task Report",
          },
          ...(roleCode === "R001" || roleCode === "R010" || roleCode === "R011"
            ? [
              {
                id: 3,
                reportName: "Non-Compliance Summary Report",
              },
              {
                id: 5,
                reportName: "Employee Timesheet Details",
              },
            ]
            : []),
        ],

        ...(roleCode === "R001" || roleCode === "R010" || roleCode === "R011"
          ? {
            "Leave": [
              {
                id: 6,
                reportName: "Employee Leave Details",
              },
              {
                id: 8,
                reportName: "Employee Leaves Summary",
              },
            ],
            "Employee Information": [
              {
                id: 7,
                reportName: "Employee Manager Information",
              },
              ...(roleCode === "R001" || roleCode === "R011"
                ? [
                  ...(roleCode === "R011" ? [{
            id: 4,
            reportName: "Employee Info Report",
                }]:[]),
                  {
                    id: 9,
                    reportName: "Attendance Report",
                  },
                  {
                    id: 10,
                    reportName: "Rp Attendance Report",
                  },
                  {
                    id: 11,
                    reportName: "Resignation Submission Report",
                  },
                  ...(roleCode === "R011" ? [ {
                  id: 12,
                  reportName: "Employee Self-Update Information Report",
                },
                {
                  id: 13,
                  reportName: "Employee Documents",
                }]:[])

                ]
                : []),
            ],
          }
          : {
            "Employee Information": [
              ...(roleCode === "R003"
                ? [
                  {
                    id: 9,
                    reportName: "Attendance Report",
                  },
                  ...(roleCode === "R004"
                    ? [
                      {
                        id: 10,
                        reportName: "Rp Attendance Report",
                      },
                    ]
                    : []
                  )
                ]
                : []),
            ],
          }),
      }


  function setReports(tab) {
    switch (tab) {
      case 1:
        return <TimesheetSummary setDisableDropdown={setDisableDropdown} />;
      case 2:
        return <ProjectSetup setDisableDropdown={setDisableDropdown} />;
      case 9:
        return <EmployeeAttendanceDetails setDisableDropdown={setDisableDropdown} />;
      case 10:
        return <RpEmployeeAttendanceDetails setDisableDropdown={setDisableDropdown} />;
      case 11:
        return <EmployeeResignationDetails setDisableDropdown={setDisableDropdown} />;
      case 3:
        if (roleCode == "R001" || roleCode === "R010" || roleCode === "R011" || roleCode === 'R004') {
          return (
            <EmployeeNonComplainceSummary
              setDisableDropdown={setDisableDropdown}
            />
          );
        }
      case 4:
        return <EmployeeInfoReport setDisableDropdown={setDisableDropdown} />;
      case 5:
        return (
          <EmployeeTimesheetDetails setDisableDropdown={setDisableDropdown} />
        );
      case 6:
        return <EmployeeLeaveDetails setDisableDropdown={setDisableDropdown} />;

      case 7:
        return <EmployeeManagerInformation setDisableDropdown={setDisableDropdown} />;

      case 8:
        return <EmployeeLeavesSummary setDisableDropdown={setDisableDropdown} />;
        case 12:
        return <ExperienceSubmissionReport   setDisableDropdown={setDisableDropdown} />;
        case 13:
        return <EmployeeDocuments   setDisableDropdown={setDisableDropdown} />;
      default:
        return;
    }
  }

  return (
    <Card variant="outlined" sx={{ padding: "30px" }}>
      <Grid container>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <Box className="label">Select a Report</Box>
          <FormControl fullWidth>
            <Select
              id="maritalStatus"
              displayEmpty
              placeholder="Select ID Proof"
              inputProps={{ "aria-label": "Without label" }}
              disabled={disableDropdown}
              value={currentReport}
              onChange={(e) => {
                setCurrentReport(e.target.value);
              }}
              renderValue={(selectedId) => {
                const selectedReport = Object.values(reports2)
                  .flat()
                  .find((report) => report.id === selectedId);
                return selectedReport
                  ? selectedReport.reportName
                  : "Select a report";
              }}
            >
              {/* {reports.map((report, index) => (
                <MenuItem key={index} value={report.id}>
                  {report.reportName}
                </MenuItem>
              ))} */}
              {Object.keys(reports2)?.map((key, i) => [
                <ListSubheader
                  key={`header-${i}`}
                  style={{
                    fontWeight: "bold",
                    borderBottom: "2px solid",
                    background: "rgb(202 200 200)",
                  }}
                >
                  {key}
                </ListSubheader>,
                reports2?.[key]?.map((obj, j) => (
                  <MenuItem value={obj.id} key={j}>
                    &nbsp;&nbsp;{j + 1}. {obj.reportName}
                  </MenuItem>
                )),
              ])}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      
      <div>{setReports(currentReport)}</div>
    </Card>
  );
}
